var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.5742 4.8889H8.69766V3.65433C8.69766 3.1852 8.99395 3.08643 9.21617 3.08643C9.4384 3.08643 10.5495 3.08643 10.5495 3.08643V1.03705H8.72235C6.69766 1.03705 6.22852 2.56791 6.22852 3.53088V4.8889H5.04333V6.98766H6.22852C6.22852 9.67902 6.22852 12.9383 6.22852 12.9383H8.69766C8.69766 12.9383 8.69766 9.65433 8.69766 6.98766H10.3767L10.5742 4.8889Z","fill":"black"}));
}

FacebookIcon.defaultProps = {"viewBox":"0 0 15 14","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
